import React, {Component} from 'react'

class PlayerVimeo {
  constructor(id, container) {

    this.id = this._parseID(id);
    this.container = container;
    DMLoader.load(this._onLoaded.bind(this))
  }

  get imageURL() {
    return Promise.resolve('https://www.dailymotion.com/thumbnail/video/' + this.id)
  }

  play() {
    this.waitingForPlay = true;
    if (this.loaded) {
      this.player = DM.player(this.container, {
        height: '100%',
        width: '100%',
        video: this.id,
        params: {
          autoplay: true,
          mute: true
        }
      })

      this.player.addEventListener('ready', this._onReady.bind(this))
      this.player.addEventListener('playing', this._onPlay.bind(this))

      this.waitingForPlay = false;
    } else {
      this.waitingForPlay = true;
    }

  }

  stop() {
    if (this.player)
      this.player.pause();
  }

  set onPlayCallback(fn) {
    if (typeof fn === "function")
      this._onPlay = fn;
  }

  _onPlay() {

  }

  _onReady() {
    this.player.play();
  }

  _onLoaded() {
    this.loaded = true;
    if (this.waitingForPlay)
      this.play();
  }

  //
  // UTILS
  //
  _parseID(id) {
    if (id.indexOf('/') === -1)
      return id;

    let exp = new RegExp('!^.+dailymotion\.com/(video|hub)/([^_]+)[^#]*(#video=([^_&]+))?|(dai\.ly/([^_]+))!', 'i')
    let match = id.match(exp);
    if (match) {
      if (match.length >= 6) {
        return match[6];
      }
      if (match.length >= 4) {
        return match[4];
      }
      return match[2];
    }
    return id;
  }
}

export default (PlayerVimeo)

const DMLoader = {
  loading: false,
  loaded: false,
  _callbacks: [],
  load(cb){
    this._addCallback(cb);
    if (this.loading)
      return;
    if (this.loaded)
      return cb();
    window.dmAsyncInit = this.onLoaded.bind(this);
    var tag = document.createElement('script');
    tag.src = "https://api.dmcdn.net/all.js";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  },
  onLoaded()  {
    this.loaded = true;
    this.loading = false;
    this._callbacks.forEach((cb) => {
      cb();
    })
  },
  _addCallback(cb)  {
    if (this._callbacks.indexOf(cb) === -1)
      this._callbacks.push(cb);
  }
};



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/players/PlayerDailymotion.js